module.exports = __webpack_public_path__ + "static/media/cat.0a05f336.ogg";